var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackUploadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7314_73998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.68199C19.5 6.88635 19.1839 6.12326 18.6213 5.56065L14.6894 1.62868C14.1267 1.06607 13.3637 0.75 12.568 0.75H3.75C2.09315 0.75 0.75 2.09314 0.75 3.75V4.5C0.75 4.91422 1.08579 5.25 1.5 5.25C1.91421 5.25 2.25 4.91422 2.25 4.5V3.75C2.25 2.92157 2.92158 2.25 3.75 2.25H12.568C12.9659 2.25 13.3474 2.40804 13.6287 2.68934L17.5606 6.62134C17.842 6.90263 18 7.28415 18 7.68199V10.8852C18.5177 10.9136 19.0198 11.0003 19.5 11.1388V7.68199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 20.25V8.25C2.25 7.83578 1.91421 7.5 1.5 7.5C1.08579 7.5 0.75 7.83578 0.75 8.25V20.25C0.75 21.9069 2.09314 23.25 3.75 23.25H13.8925C13.2771 22.8408 12.7327 22.3334 12.2817 21.75H3.75C2.92157 21.75 2.25 21.0784 2.25 20.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 18.375C10.3911 18.375 10.6535 18.3587 10.9111 18.327C10.8872 18.0963 10.875 17.8621 10.875 17.625C10.875 17.3491 10.8915 17.0771 10.9237 16.8099C10.6638 16.8527 10.397 16.875 10.125 16.875C7.43261 16.875 5.25 14.6924 5.25 12C5.25 9.30761 7.43261 7.125 10.125 7.125C12.6208 7.125 14.6785 9.00049 14.9657 11.419C15.4261 11.2215 15.9128 11.0737 16.4192 10.9824C15.932 7.94527 13.2995 5.625 10.125 5.625C6.6042 5.625 3.75 8.4792 3.75 12C3.75 15.5208 6.6042 18.375 10.125 18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.25C10.5392 8.25 10.875 8.58578 10.875 9V12C10.875 12.4142 10.5392 12.75 10.125 12.75H8.25C7.83578 12.75 7.5 12.4142 7.5 12C7.5 11.5858 7.83578 11.25 8.25 11.25H9.375V9C9.375 8.58578 9.71078 8.25 10.125 8.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 19.875C16.875 20.2892 17.2108 20.625 17.625 20.625C18.0392 20.625 18.375 20.2892 18.375 19.875V17.2343L18.9599 17.8413C19.2473 18.1396 19.7221 18.1484 20.0204 17.861C20.3187 17.5736 20.3275 17.0988 20.0401 16.8006L18.1651 14.8546C18.0237 14.7079 17.8287 14.625 17.625 14.625C17.4213 14.625 17.2263 14.7079 17.0849 14.8546L15.2099 16.8006C14.9225 17.0988 14.9313 17.5736 15.2296 17.861C15.5279 18.1484 16.0027 18.1396 16.2901 17.8413L16.875 17.2343V19.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 17.625C23.25 14.5184 20.7316 12 17.625 12C14.5184 12 12 14.5184 12 17.625C12 20.7316 14.5184 23.25 17.625 23.25C20.7316 23.25 23.25 20.7316 23.25 17.625ZM17.625 13.5C19.9032 13.5 21.75 15.3468 21.75 17.625C21.75 19.9032 19.9032 21.75 17.625 21.75C15.3468 21.75 13.5 19.9032 13.5 17.625C13.5 15.3468 15.3468 13.5 17.625 13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7314_73998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackUploadsIcon);
export default __webpack_public_path__ + "static/media/TrackUploadsIcon.b0acab9d40d66d1b54caf3bc6d29769a.svg";
export { ForwardRef as ReactComponent };